import { render, staticRenderFns } from "./PromoProductCard.vue?vue&type=template&id=557c5c87&scoped=true&"
import script from "./PromoProductCard.vue?vue&type=script&lang=js&"
export * from "./PromoProductCard.vue?vue&type=script&lang=js&"
import style0 from "./PromoProductCard.vue?vue&type=style&index=0&id=557c5c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c5c87",
  null
  
)

export default component.exports